export const KubernetesFeatures = {
    ConfigMap: "Octopus.Features.KubernetesConfigMap",
    Secret: "Octopus.Features.KubernetesSecret",
    CustomResource: "Octopus.Features.KubernetesCustomResource",
    Ingress: "Octopus.Features.KubernetesIngress",
    Service: "Octopus.Features.KubernetesService",
} as const;
export type KubernetesFeature = (typeof KubernetesFeatures)[keyof typeof KubernetesFeatures];
